import { render, staticRenderFns } from "./CreateDialog.vue?vue&type=template&id=2fbfb1d9&scoped=true"
import script from "./CreateDialog.ts?vue&type=script&lang=ts&external"
export * from "./CreateDialog.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbfb1d9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fbfb1d9')) {
      api.createRecord('2fbfb1d9', component.options)
    } else {
      api.reload('2fbfb1d9', component.options)
    }
    module.hot.accept("./CreateDialog.vue?vue&type=template&id=2fbfb1d9&scoped=true", function () {
      api.rerender('2fbfb1d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/S3Connector/components/CreateDialog/CreateDialog.vue"
export default component.exports